<template>
  <b-container>
    <b-row align-h="center">
      <b-col cols="12" md="8" lg="6" class="py-3">
        <div v-show="!updateSuccess">
          <b-form @submit.prevent="updateProfile">
            <b-form-group :label="$t('profile:user-email-label')"
                          label-for="email-address">
              <b-form-input id="email-address"
                            name="email-address"
                            type="email"
                            required
                            v-model="profileUser.email"
                            :placeholder="$t('common:email-placeholder')">
              </b-form-input>
            </b-form-group>
            <b-form-group :label="$t('profile:user-password-label')"
                          label-for="password"
                          :description="$t('profile:user-password-description')">
              <b-form-input id="password"
                            type="password"
                            v-model="profileUser.password"
                            :placeholder="$t('profile:user-password-placeholder')">
              </b-form-input>
            </b-form-group>
            <b-form-group class="text-right" v-if="!passwordRecovery">
              <b-button id="submit-button_save-profile" type="submit" variant="success">{{$t('common:save')}}</b-button>
            </b-form-group>
            <b-form-group class="text-right" v-if="passwordRecovery">
              <b-button type="submit" :disabled="!profileUser.password || profileUser.password.length < 8" variant="success">{{$t('common:save')}}</b-button>
            </b-form-group>
          </b-form>
          <b-alert variant="warning" :show="updateFailure" dismissible>{{$t('profile:update-error')}}</b-alert>
        </div>
        <b-alert id="success-message_password-save" variant="success" :show="updateSuccess">
          <p>{{$t('profile:update-success')}}</p>
          <p v-if="numberOfPendingQuestions > 0">{{$t('profile:pending-questions-prompt')}}<br/><br/><b-button variant="success" to="/personal/survey">{{$t('profile:pending-questions-cta')}}</b-button></p>
        </b-alert>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      profileUser: {},
      updateSuccess: false,
      updateFailure: false
    }
  },
  props: ['passwordRecovery'],
  mounted: function () {
    this.profileUser = this.$store.state.user
  },
  methods: {
    updateProfile () {
      this.updateFailure = false
      this.updateSuccess = false
      this.axios.post('/users/' + this.$store.state.user._id, { user: this.profileUser }).then((response) => {
        this.$store.dispatch('updateUser', response.data.user)
        this.updateSuccess = true
      }).catch(() => {
        this.updateFailure = true
      })
    }
  },
  computed: {
    ...mapGetters(['user', 'numberOfPendingQuestions'])
  },
  watch: {
    user (value) {
      this.profileUser = value
    },
    messagingOptions: {
      deep: true,
      handler () {
        this.makeToast()
      }
    }
  }
}
</script>
